import React from 'react';
import { OptionPill } from './QuestionOption';
import { useTranslation } from 'react-i18next';
import TextDir from '../lib/TextDir';
export const SimpleOption = ({ onClick, disabled, value, }) => {
    const { i18n } = useTranslation();
    return (React.createElement(OptionPill, { disabled: disabled, size: "small", onClick: onClick, "data-testid": "simple-option" },
        React.createElement(TextDir, { locale: i18n.language }, value)));
};
